// Availability labels only; publish numerical outcomes once operational data is connected.
export default function SustainabilityImpactStrip() {
  return <section className="mb-10 py-8 px-4 bg-zinc-950/90 border-y border-emerald-500/30" data-testid="sustainability-impact-strip">
    <h2 className="text-lg text-center text-emerald-300 mb-6" data-testid="sustainability-tracking-heading">Sustainability reporting capabilities</h2>
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
      {[
        ['waste-diversion', 'Waste Diversion Tracking'],
        ['recycling', 'Recycling Reporting'],
        ['water-conscious', 'Water-Conscious Service Tracking'],
      ].map(([key, label]) => <div key={key} className="text-center" data-testid={`sus-impact-${key}`}>
        <p className="text-sm text-zinc-200 mb-3" data-testid={`sus-impact-${key}-label`}>{label}</p>
        <p className="text-xl font-semibold text-emerald-300" data-testid={`sus-impact-${key}-status`}>Available</p>
      </div>)}
    </div>
  </section>;
}